import React, { Component, Suspense, lazy } from 'react';
import {
    HashRouter,
    BrowserRouter as Router,
    Route,
    Redirect,
    Switch,
} from 'react-router-dom';
import config from '@config/index.ts';
import { isInAPP } from '@utils/types';
import { getLiveIndex } from '@api/index';
// import { loadJS } from '@src/utils/utils';
// import { withQuicklink } from 'quicklink/dist/react/hoc.js';
const options = {
    origins: []
};

const RouterConf = [
    {
        path: '/',
        component: lazy(() =>
            // import(/* webpackPreload: true */  '@views/Index/index')
            import(/* webpackChunkName: 'index' */ '@views/Index/index')
        )
    },
    {
        path: '/mine',
        component: lazy(() =>
            // import(/* webpackPreload: true */  '@views/Index/index')
            import(/* webpackChunkName: 'mine' */ '@views/Mine/index')
        ),
    },
    {
        path: '/mp',
        component: lazy(() =>
            // import(/* webpackPreload: true */  '@views/Index/index')
            import(/* webpackChunkName: 'mp' */ '@views/Middlepage/index')
        ),
    },
    {
        path: '/city',
        component: lazy(() =>
            // import(/* webpackPreload: true */  '@views/Index/index')
            import(/* webpackChunkName: 'city' */ '@views/CityList/index')
        ),
    },
    {
        path: '/reserve',
        component: lazy(() =>
            // import(/* webpackPreload: true */  '@views/Index/index')
            import(/* webpackChunkName: 'city' */ '@views/Reserve/index')
        ),
    },
    // {
    //     path: '/livestreaming',
    //     component: lazy(() =>
    //         // import(/* webpackPreload: true */  '@views/LiveStreaming/index')
    //         import(/* webpackChunkName: 'livestreaming' */ '@views/LiveStreaming/index')
    //     ),
    // },
];

class RouterConfig extends Component {
    componentDidCatch(error: any, errorInfo: any) {
        window.Beidou && window.Beidou.captureException(error, errorInfo);
    }
    async componentDidMount() {  
   
        if (isInAPP) {
            setTimeout(() => {
                // 最新版埋点 10.24.0版本以上使用
                const appVersion = window.WBAPP.common.appVersion;
                if(parseInt(window.WBAPP.util.compareVersion(appVersion, "10.24.0")) >= 0){
                    let options = {
                        page_type: 'special',
                        action_type: 'enter',
                        cate: "9224",
                        realtime: false,
                        top_level: false,
                        json:{
                            url:'' + window.location.origin + window.location.pathname 
                        }
                    } 
                    window.WBAPP.invoke("job_weblog" , options);
                    return;
                }
                window.WBAPP && window.WBAPP.action && window.WBAPP.action.setWeblog('special', 'enter', { cate: '9224' });
            }, 100)
        }
    }
    render() {
        return (
            <>
                <HashRouter>
                    <Suspense fallback={<div></div>}>
                        <Switch>
                            {RouterConf.map((config, index: number) => (
                                <Route exact key={index} {...config} />
                            ))}
                            <Redirect to="/" />
                        </Switch>
                    </Suspense>
                </HashRouter>
            </>
        );
    }
}

export default RouterConfig;
